'use client';

import { Store } from '@/core/entities/store';

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

export interface GlobalInfoState {
  title?: string;
  description: string;
  hideBackButton: boolean;
}

export interface GlobalInfoContextType {
  globalInfo: GlobalInfoState;
  setGlobalInfo: Dispatch<SetStateAction<GlobalInfoState>>;
  stores: Store[];
}

const GlobalInfoContext = createContext<GlobalInfoContextType | undefined>(undefined);

interface GlobalInfoProviderProps {
  children: ReactNode;
  stores: Store[];
}

export const GlobalInfoProvider = ({ children, stores }: GlobalInfoProviderProps) => {
  const [globalInfo, setGlobalInfo] = useState<GlobalInfoState>({
    title: undefined,
    description: 'Información compartida en el widget.',
    hideBackButton: false
  });

  return (
    <GlobalInfoContext.Provider value={{ globalInfo, setGlobalInfo, stores }}>
      {children}
    </GlobalInfoContext.Provider>
  );
};

export const useGlobalInfo = (): GlobalInfoContextType => {
  const context = useContext(GlobalInfoContext);
  if (context === undefined) {
    throw new Error('useGlobalInfo debe ser usado dentro de un GlobalInfoProvider');
  }
  return context;
};
